import type { Capability } from '@/domain/types'
import { useApiQuery, type QueryState } from '@/api/useApiQuery'

export interface CapabilityQuery {
  includeInactive?: boolean
  asOf?: string
}

/**
 * Fetches GET /api/capabilities/{id}. Detail response includes optional
 * `children` (when capabilityLevel === 1) or `parent` (when level === 2).
 */
export function useCapability(
  capabilityId: number,
  query: CapabilityQuery = {},
): QueryState<Capability> {
  const params = new URLSearchParams()
  if (query.includeInactive) params.set('includeInactive', 'true')
  if (query.asOf) params.set('asOf', query.asOf)
  const qs = params.toString()
  const path = qs ? `/api/capabilities/${capabilityId}?${qs}` : `/api/capabilities/${capabilityId}`
  return useApiQuery<Capability>(path)
}
